"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AreaChart = exports.getConfigProps = exports.getBucketsProps = void 0;
var tslib_1 = require("tslib");
// (C) 2007-2019 GoodData Corporation
var react_1 = tslib_1.__importDefault(require("react"));
var sdk_model_1 = require("@gooddata/sdk-model");
var truncate_1 = require("../_commons/truncate");
var interfaces_1 = require("../../interfaces");
var sdk_ui_1 = require("@gooddata/sdk-ui");
var dimensions_1 = require("../_commons/dimensions");
var CoreAreaChart_1 = require("./CoreAreaChart");
var isNil_1 = tslib_1.__importDefault(require("lodash/isNil"));
var withChart_1 = require("../_base/withChart");
var sanitizeStacking_1 = require("../_commons/sanitizeStacking");
//
// Internals
//
var areaChartDefinition = {
    chartName: "AreaChart",
    bucketPropsKeys: ["measures", "viewBy", "stackBy", "filters", "sortBy"],
    bucketsFactory: function (props) {
        var _a = getBucketsProps(props), measures = _a.measures, viewBy = _a.viewBy, stackBy = _a.stackBy;
        var sanitizedMeasures = sdk_model_1.applyRatioRule(measures);
        return [
            sdk_model_1.newBucket.apply(void 0, tslib_1.__spreadArrays([sdk_ui_1.BucketNames.MEASURES], sanitizedMeasures)),
            sdk_model_1.newBucket.apply(void 0, tslib_1.__spreadArrays([sdk_ui_1.BucketNames.VIEW], viewBy)),
            sdk_model_1.newBucket.apply(void 0, tslib_1.__spreadArrays([sdk_ui_1.BucketNames.STACK], stackBy)),
        ];
    },
    executionFactory: function (props, buckets) {
        var _a;
        var backend = props.backend, workspace = props.workspace, execConfig = props.execConfig;
        return (_a = backend
            .withTelemetry("AreaChart", props)
            .workspace(workspace)
            .execution()
            .forBuckets(buckets, props.filters))
            .withSorting.apply(_a, props.sortBy).withDimensions(dimensions_1.stackedChartDimensions)
            .withExecConfig(execConfig);
    },
    propOverridesFactory: function (props, buckets) {
        var config = getConfigProps(props);
        return {
            config: sanitizeStacking_1.sanitizeConfig(buckets, config),
        };
    },
    onBeforePropsConversion: verifyBuckets,
};
function getStackConfiguration(config) {
    if (config === void 0) { config = {}; }
    var stackMeasures = config.stackMeasures, stackMeasuresToPercent = config.stackMeasuresToPercent;
    if (isNil_1.default(stackMeasures) && isNil_1.default(stackMeasuresToPercent)) {
        return config;
    }
    return tslib_1.__assign(tslib_1.__assign({}, config), { stacking: Boolean(stackMeasuresToPercent) || Boolean(stackMeasures) });
}
function getBucketsProps(props) {
    var measures = props.measures, stackBy = props.stackBy;
    var viewBy = truncate_1.truncate(props.viewBy, interfaces_1.ViewByAttributesLimit);
    if (viewBy.length <= 1) {
        return {
            measures: measures || [],
            viewBy: viewBy,
            stackBy: stackBy ? [stackBy] : [],
        };
    }
    // for case viewBy 2 attributes
    var firstMeasure = measures[0]; // only take first measure
    var firstAttribute = viewBy[0], secondAttribute = viewBy[1]; // only take first two attributes
    return {
        measures: [firstMeasure],
        viewBy: [firstAttribute],
        stackBy: [secondAttribute],
    };
}
exports.getBucketsProps = getBucketsProps;
function getConfigProps(props) {
    var viewBy = truncate_1.truncate(props.viewBy, interfaces_1.ViewByAttributesLimit);
    if (viewBy.length <= 1) {
        return getStackConfiguration(props.config);
    }
    return tslib_1.__assign(tslib_1.__assign({}, props.config), { stacking: false, stackMeasures: false, stackMeasuresToPercent: false });
}
exports.getConfigProps = getConfigProps;
/**
 * Show warning to SDK user in console log
 */
function verifyBuckets(props) {
    var viewBy = truncate_1.truncate(props.viewBy, interfaces_1.ViewByAttributesLimit);
    if (viewBy.length <= 1) {
        return;
    }
    var _a = props.measures, measures = _a === void 0 ? [] : _a, stackBy = props.stackBy;
    if (measures.length > 1 || stackBy) {
        // eslint-disable-next-line no-console
        console.warn("When there are two attributes in viewBy, only first measure is taken and attribute in stackBy is ignored");
    }
}
var WrappedAreaChart = withChart_1.withChart(areaChartDefinition)(CoreAreaChart_1.CoreAreaChart);
/**
 * [AreaChart](http://sdk.gooddata.com/gooddata-ui/docs/area_chart_component.html)
 *
 * Area chart shows data as an area under a line intersecting dots. It can display either:
 *
 * - multiple measures sliced by a single attribute, as different areas
 * - or a single measure split by one attribute into multiple areas with points intersecting attribute values
 *
 * Areas for multiple measures stack by default. Alternatively, the areas can overlap if `{ stackMeasures: false }`.
 *
 * @remarks See {@link IAreaChartProps} to learn how it is possible to configure the AreaChart
 * @public
 */
exports.AreaChart = function (props) {
    var _a = sdk_ui_1.useResolveValuesWithPlaceholders([props.measures, props.viewBy, props.stackBy, props.filters, props.sortBy], props.placeholdersResolutionContext), measures = _a[0], viewBy = _a[1], stackBy = _a[2], filters = _a[3], sortBy = _a[4];
    return (react_1.default.createElement(WrappedAreaChart, tslib_1.__assign({}, props, {
        measures: measures,
        viewBy: viewBy,
        stackBy: stackBy,
        filters: filters,
        sortBy: sortBy,
    })));
};
//# sourceMappingURL=AreaChart.js.map